import { render, staticRenderFns } from "./MentionModal.vue?vue&type=template&id=a6c39f08"
import script from "./MentionModal.vue?vue&type=script&lang=js"
export * from "./MentionModal.vue?vue&type=script&lang=js"
import style0 from "./MentionModal.vue?vue&type=style&index=0&id=a6c39f08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports